import DataMap from 'assets/components/dataMap/DataMap';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales, Language } from 'assets/locales/Locale';
import { values } from 'lodash';
import { useDealerGroupProvider } from '../../DealerGroup.Hooks';
import ProductEnhancementDocumentTranslation from './DealerGroup.ProductEnhancementDocumentTranslation';
import { Fragment } from 'react';

const DealerGroupProductEnhancementDocumentForm = () => {
  const { productEnhancementsPayload } = useDealerGroupProvider();
  const { lang } = getLocales();

  return (
    <table className={ThemeTableSimple}>
      <DataMap
        data={productEnhancementsPayload?.data ?? []}
        render={({ data: product }) =>
          !product.productEnhancementDocuments.length ? null : (
            <Fragment key={product.id}>
              <thead>
                <tr>
                  <th>{product.name}</th>
                  <DataMap
                    data={values(Language)}
                    render={({ data: langIsoCode }) => <th key={langIsoCode}>{lang[langIsoCode]}</th>}
                  />
                </tr>
              </thead>
              <tbody>
                <DataMap
                  data={product.productEnhancementDocuments}
                  render={({ data: productEnhancementDocument }) => {
                    return (
                      <tr key={productEnhancementDocument.id}>
                        <td>{productEnhancementDocument.displayInfo.title}</td>
                        <DataMap
                          data={values(Language)}
                          render={({ data: languageIsoCode }) => (
                            <td key={languageIsoCode}>
                              <ProductEnhancementDocumentTranslation
                                languageIsoCode={languageIsoCode}
                                productEnhancementDocument={productEnhancementDocument}
                              />
                            </td>
                          )}
                        />
                      </tr>
                    );
                  }}
                />
              </tbody>
            </Fragment>
          )
        }
      />
    </table>
  );
};

export default DealerGroupProductEnhancementDocumentForm;
